module.exports = __webpack_public_path__ + "static/media/floor.644ca0ed.svg";